const PaySuccess = () => {
    return 'Pay Success!'
}

export default PaySuccess